import { render } from "./communityPage.vue?vue&type=template&id=7b71ffd0"
import script from "./communityPage.vue?vue&type=script&lang=js"
export * from "./communityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__